import { render, staticRenderFns } from "./UserFormDrawer.vue?vue&type=template&id=2b9dea6a&scoped=true&"
import script from "./UserFormDrawer.vue?vue&type=script&lang=js&"
export * from "./UserFormDrawer.vue?vue&type=script&lang=js&"
import style0 from "./UserFormDrawer.vue?vue&type=style&index=0&id=2b9dea6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9dea6a",
  null
  
)

export default component.exports